export const DOTS = '...'
export function getPaginationRange(
  currentPage: number,
  totalPages: number,
  totalPageNumbers: 7 | 5 | 4 | 1,
): (number | string)[] {
  if (totalPages <= totalPageNumbers) {
    return Array.from({ length: totalPages }, (_, index) => index + 1)
  }

  const leftSiblingIndex = Math.max(currentPage - 1, 1)
  const rightSiblingIndex = Math.min(currentPage + 1, totalPages)

  const firstPageIndex = 1
  const lastPageIndex = totalPages

  if (totalPageNumbers === 1) {
    return [currentPage]
  }

  if (totalPageNumbers === 4) {
    if (currentPage === 1) {
      return [firstPageIndex, firstPageIndex + 1, DOTS, lastPageIndex]
    }
    if (currentPage === firstPageIndex + 1) {
      return [firstPageIndex, currentPage, DOTS, lastPageIndex]
    }
    if (currentPage === totalPages) {
      return [firstPageIndex, DOTS, lastPageIndex - 1, lastPageIndex]
    }
    if (currentPage === totalPages - 1) {
      return [firstPageIndex, DOTS, currentPage, lastPageIndex]
    }
    return [firstPageIndex, DOTS, currentPage, DOTS]
  }

  if (totalPageNumbers === 5) {
    if (currentPage <= 3) {
      return [1, 2, 3, DOTS, lastPageIndex]
    }
    if (currentPage >= totalPages - 2) {
      return [firstPageIndex, DOTS, totalPages - 2, totalPages - 1, totalPages]
    }
    return [firstPageIndex, DOTS, currentPage, DOTS, lastPageIndex]
  }

  if (totalPageNumbers === 7) {
    if (currentPage <= 4) {
      return [1, 2, 3, 4, 5, DOTS, lastPageIndex]
    }
    if (currentPage >= totalPages - 3) {
      return [firstPageIndex, DOTS, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages]
    }
    if (currentPage === leftSiblingIndex && rightSiblingIndex < totalPages - 1) {
      return [firstPageIndex, DOTS, leftSiblingIndex, currentPage, rightSiblingIndex, DOTS, lastPageIndex]
    }
    if (currentPage === rightSiblingIndex && leftSiblingIndex > 2) {
      return [firstPageIndex, DOTS, leftSiblingIndex, currentPage, rightSiblingIndex, DOTS, lastPageIndex]
    }
    return [firstPageIndex, DOTS, leftSiblingIndex, currentPage, rightSiblingIndex, DOTS, lastPageIndex]
  }
  return []
}
